import axios from 'axios'
import { getHeaders } from '../utils/main'
import endpoints from './endpoints'

export const fetchVersions = async (params) => {
  const callResponse = await axios({
    url: endpoints.fetchVersion,
    method: 'get',
    headers: getHeaders(),
    params
  })
    .then((response) => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))

  return callResponse
}

export const fetchLatestVersion = async (params) => {
  const callResponse = await axios({
    url: endpoints.latestVersion,
    method: 'get',
    headers: getHeaders(),
    params
  })
    .then((response) => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))

  return callResponse
}

export const createVersion = async (data) => {
  const callResponse = await axios({
    url: endpoints.CreateVersion,
    method: 'post',
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))

  return callResponse
}

export const deleteVersion = async (data) => {
  const callResponse = await axios({
    url: endpoints.deleteVersion,
    method: 'delete',
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => ({ status: 0, response: err.response, code: err.response.status }))

  return callResponse
}

